import React from "react";
import waveGif from "../../assets/images/wave-home.gif";
import smartContract from "../../assets/images/smart-contracts-home-animation.png";
import smartContractMobile from "../../assets/images/smart-contracts-home-animation-mobile.png";
import featureOne from "../../assets/images/feature-secure-home.svg";
import featureTwo from "../../assets/images/feature-lowfee-home.svg";
import featureThree from "../../assets/images/feature-email-home.svg";
import stepOne from "../../assets/images/step-1-home.png";
import stepTwo from "../../assets/images/step-2-home.png";
import stepThree from "../../assets/images/step-3-home.png";
import stepOneMobile from "../../assets/images/step-1-home-mobile.png";
import stepTwoMobile from "../../assets/images/step-2-home-mobile.png";
import stepThreeMobile from "../../assets/images/step-3-home-mobile.png";
import homeBottomGrid from "../../assets/images/footer-home.png";
import homeBannerChart from "../../assets/images/home-banner-pie-chart.svg";
import ethereum from "../../assets/images/ethereum.png";
import homeBannerBtm from "../../assets/images/bottom part.png";

type Props = {
  history: any;
  location: any;
  token: string | null;
};

const HomeComponent = ({ history, token }: Props) => {

  const handleRedirection = () =>{
    if (token) {
      history.push('/create')
    }else{
      history.push('/login')
    }
  }
  return (
    <div className="ethsplitter ethsplitter__home">
      <div className="ethsplitter__home__banner ethsplitter__commonBanner">
        <span className="bannerMerge"></span>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-xl-5 ethsplitter__commonBanner__content banner__content">
              <h1>Ethereum Splitter</h1>
              <p className="color-muted">
              Software that allows you and your team to pay multiple people at once by sending Ethereum or ERC20 tokens to a single address.
              </p>
            </div>
            <div className="col-lg-6 col-xl-7">
              <div className="ethsplitter__banner__media">
                <div className="ethsplitter__banner__tooltip ethsplitter__banner__topchart wow  animate__fadeInDown " data-wow-duration="2s"  >
                  {" "}
                  <img
                    src={homeBannerChart}
                    alt="banner-gif"
                    className="img-fluid"
                  />
                </div>
                <div className="ethsplitter__banner__tooltip ethsplitter__banner__ethereum  wow  animate__fadeInDown"   data-wow-duration="2.8s" >
                  <img src={ethereum} alt="banner-img" className="img-fluid" />
                </div>
                <div className="ethsplitter__banner__tooltip ethsplitter__banner__btm ">
                  <img
                    src={homeBannerBtm}
                    alt="banner-gif"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ethsplitter__smartcontract b-burger">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 order-lg-2 ethsplitter__section__content right">
              <h2>Smart Contracts</h2>
              <p className="color-muted">
              Here at ETH Splitter, we use smart contacts to help create payment share structures. You can use these tools to create contracts which will give you peace of mind, as our system protects your agreement and makes sure that issues don’t arise.
              </p>
            </div>
            <div className="col-lg-7 order-lg-1  ethsplitter__section__media">
              <div className="ethsplitter__smart__tooltip-wrapr">
              <img className="img-fluid d-none d-lg-block" src={smartContract}  alt="smart-contract" />
              <img className="img-fluid d-lg-none" src={smartContractMobile}  alt="smart-contract" />
                <div className="ethsplitter__smart__tooltip tooltip1 wow animate__fadeInUp" data-wow-duration="1.5s"  >
                  <span>35%</span>
                  <div>Lianaa Spark</div>
                  {/* <img src={member1} alt="" /> */}
                </div>
                <div className="ethsplitter__smart__tooltip tooltip2 wow animate__fadeInUp"  data-wow-duration="1.5s" >
                  <span>25%</span>
                  <div>Anjelic Tricton</div>
                  {/* <img src={member2} alt="" /> */}
                </div>
                <div className="ethsplitter__smart__tooltip tooltip3 wow animate__fadeInUp" data-wow-duration="1.5s" >
                  <span>20%</span>
                  <div>Leo Dagger</div>
                  {/* <img src={member3} alt="" /> */}
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      <div className="ethsplitter__home__features b-burger">
        <div className="container">
          <div className="common__heading text-center">
            <h2>Features</h2>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="ethsplitter__card card ">
                <div className="card-body">
                  <span className="float__shadow__icon">
                    <img
                      className="img-fluid"
                      src={featureOne}
                      alt="smart-contract"
                    />
                  </span>
                  <h5 className="card-title">Secure</h5>
                  <p className="card-text color-muted">
                  Our system is built to be secure and uses cutting edge tools and technology to make sure that you are safe, protected, and that your contracts are in good hands from the outset. 

                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="ethsplitter__card card ">
                <div className="card-body">
                  <span className="float__shadow__icon">
                    <img
                      className="img-fluid"
                      src={featureTwo}
                      alt="smart-contract"
                    />
                  </span>
                  <h5 className="card-title">Low Fees</h5>
                  <p className="card-text color-muted">
                  To make sure that you’re not losing out from using the service, we make it so that you only have to pay 0.1% of every transaction that you make. This means you’re free to get on with what you know to be important and not have to pay more to run the business. 

                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="ethsplitter__card card ">
                <div className="card-body">
                  <span className="float__shadow__icon">
                    <img
                      className="img-fluid"
                      src={featureThree}
                      alt="smart-contract"
                    />
                  </span>
                  <h5 className="card-title">Email Alerts</h5>
                  <p className="card-text color-muted">
                  We want to make sure that you stay in the loop with your business, which is why we have provided the option to send an email notification to all of the participants. You’ll get an email that says how much every participant has received.

                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mt-5">
            <span
              onClick={() => handleRedirection()}
              className="btn btn-primary px-5 btn-shadow"
            >
              Create An ETH Split Scheme
            </span>
          </div>
        </div>
      </div>
      <div className="ethsplitter__home-wave">
        <img src={waveGif} alt="wave" className="img-fluid w-100" />
      </div>
      <div className="ethsplitter__home__steps b-burger ">
        <div className="container">
          <div className="common__heading text-center">
            <h2>How To Use the System</h2>
            <p className="color-muted">
            To get started with the system, you will need to build a Share Profile for yourself. This will require you to submit details such <br/> as the participant name, the share value, given in %, and the Ethereum address you want to work from. 

            </p>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-5 ethsplitter__section__content left">
              <h3>Step One</h3>
              <p className="color-muted">
              First of all, you will want to create your ETHSplitShare Structure. You can do this by adding the names and percentages for each share of the smart contract. 

              </p>
            </div>
            <div className="col-lg-7">
              <img className="img-fluid d-none d-lg-block" src={stepOne} alt="smart-contract" />
              <img className="img-fluid d-lg-none" src={stepOneMobile} alt="smart-contract" />
            </div>
          </div>
          <div className="row align-items-center">
           
            <div className="col-lg-5 order-lg-2  ethsplitter__section__content right">
              <h3>Step Two</h3>
              <p className="color-muted">
              Second of all, you need to make sure that you add a separate ETH address for each of the beneficiaries that you want to send money towards. 

              </p>
            </div>
            <div className="col-lg-7 order-lg-1">
              <img className="img-fluid d-none d-lg-block" src={stepTwo} alt="smart-contract" />
              <img className="img-fluid  d-lg-none" src={stepTwoMobile} alt="smart-contract" />
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-5 ethsplitter__section__content left">
              <h3>Step Three</h3>
              <p className="color-muted">
              Finally, you need to make sure that you check the summary for your planned splitting. If everything looks right for you, then you can press the “confirm” button. 

              </p>
            </div>
            <div className="col-lg-7">
              <img className="img-fluid d-none d-lg-block" src={stepThree} alt="smart-contract" />
              <img className="img-fluid d-lg-none" src={stepThreeMobile} alt="smart-contract" />
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <div className="container">
          <div className="common__heading text-center">
            <div className="row">
              <div className="col-lg-10 offset-lg-1">
                  <h2>Get in Touch Today </h2>
                  <p className="color-muted mb-0">
                  ETH Splitter is committed to making sure that your experiences are positive ones. If you have any questions or queries about any aspect of the service, then you’re welcome to get in touch with us today. A member of the team will be more than happy to make sure that your experiences are positive ones from the outset. We’ll also make sure you’re ready to start using the site as soon as possible. 
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="home__bottomGrid">
        <img className="img-fluid" src={homeBottomGrid} alt="homeBottomGrid" />
      </div>
    </div> //home wrapr End
  );
};
export default HomeComponent;
